<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex bd-highlight align-items-center">
          <div class="bd-highlight">
            <div class="side-frame-success">
              <span style="font-size: 15px; color: #606266">
                {{
                  $l('form_label_task_range_detail') || '盘点范围产品明细信息'
                }}
              </span>
              <el-divider direction="vertical"></el-divider>
            </div>
          </div>
          <div class="flex-fill bd-highlight">
            <slot name="header"> </slot>
          </div>
        </div>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:isCheckStatusInfo="{ row }">
        <el-tag
          size="mini"
          :type="row.isCheckStatus === 'Y' ? 'success' : 'info'"
        >
          {{ row.isCheckStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.stockSellCode }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.billStatus === 'N'"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.stockSellCode }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.billStatus === 'N'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.stockSellCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('C')"
            v-show="row.billStatus === 'N'"
          >
            <i
              class="el-icon-check tool-btn"
              @click="audit(row.stockSellCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableHeight: 600,
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },

        {
          title: this.$l('form_label_sample_barcode') || '样品条码',
          headerAlign: 'left',
          align: 'left',
          minWidth: 160,
          field: 'sampleBarCode'
        },
        {
          title: this.$l('form_label_sample_styleNo') || '样品款号',
          headerAlign: 'left',
          align: 'left',
          minWidth: 160,
          field: 'sampleStyleNo'
        },
        {
          title: this.$l('form_label_sample_name') || '样品名称',
          headerAlign: 'left',
          align: 'left',
          minWidth: 400,
          field: 'sampleName'
        },
        {
          title: this.$l('form_label_locationNo') || '库位编号', //""
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          field: 'locationNo'
        },
        // {
        //   title: this.$l('form_label_locationDescription') || '库位名称', //""
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 160,
        //   field: 'locationDescription'
        // },
        {
          title: this.$l('form_label_sample_bookNum') || '库存数量',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          field: 'bookNum'
        },
        {
          title: this.$l('form_label_Check_status') || '核对状态',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          field: 'isCheckStatusName',
          slots: {
            default: 'isCheckStatusInfo'
          }
        },
        {
          title: this.$l('form_label_stockStatusName') || '库存状态',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          field: 'stockStatusName'
        }
      ]
    }
  },
  methods: {}
}
</script>
